import trim from 'lodash/trim';
import cmp from '../../lib/cmp';
import onResize from '../../lib/dom/on-resize';
import { removeClass, addClass } from '../../lib/dom/className';
import template from './sm-ellipsis.template.js';
import './sm-ellipsis.less';



const FACTOR = 15;

let counter = 0;


export const mkHiddenElement = (tag, hasPreLine) => {
  const div = document.createElement(tag);

  div.id = `-sm-ellipsis-${counter++}`;

  div.style.visibility = 'hidden';
  div.style.position = 'absolute';
  div.style.top = '-100%';
  div.style.left = '-1000%';
  div.style.padding = 0;
  div.style.margin = 0;
  div.style.border = 0;
  div.style.whiteSpace = hasPreLine ? 'pre-line' : 'normal';

  div.$onInit = () => {
    document.body.appendChild(div);
  };


  div.$onDestroy = () => document.body.removeChild(div);

  return div;
};



export default cmp(null, template, (
  element, {
    text,
    rows = null,
    pre = false,
    before = '',
    append = '',
    prepend = '',
    after = '',
    onEllipsisChange,
    reservedLength = 0,
    dots = ''
  }) => {

  text = String(text || '');

  element.innerHTML = `${prepend}${text}${append}`;

  const ellipsis = () => {
    const div = mkHiddenElement('div', pre);
    const style = window.getComputedStyle(element);
    const fontSize = parseFloat(String(style.fontSize));
    const lineHeight = parseFloat(String(style.lineHeight || style['line-height'])) || fontSize;
    const letterSpacing = parseFloat(String(style.letterSpacing || style['letter-spacing'])) || 0;
    let newText = text;

    div.$onInit();

    div.style.width = `${parseFloat(String(element.offsetWidth))}px`;
    div.style.fontSize = `${fontSize}px`;
    div.style.lineHeight = `${lineHeight}px`;
    div.style.letterSpacing = letterSpacing ? `${letterSpacing}px` : 'normal';
    div.style.fontWeight = style.fontWeight || style['font-weight'] || 'normal';
    div.innerText = newText;

    let maxHeight = 0;

    if (rows) {
      maxHeight = Math.round(rows * lineHeight);
    } else {
      const styleMaxHeight = style.maxHeight || style['max-height'];

      if (styleMaxHeight) {
        if (/%/.test(styleMaxHeight)) {
          maxHeight = element.parentNode.offsetHeight * parseFloat(styleMaxHeight) / 100;
        } else {
          maxHeight = parseFloat(styleMaxHeight);
        }
      } else if (style.height) {
        maxHeight = parseFloat(style.height);
      }
    }

    if (!maxHeight) {
      element.innerHTML = `${prepend}${append}`;
      return;
    }

    if (maxHeight < lineHeight) {
      maxHeight = lineHeight;
    }

    let len = newText.length;

    for (let i = 0; i < 1000 && (newText.length) > 0; i++) {
      const height = div.clientHeight;

      if (height <= maxHeight || height <= lineHeight) {
        break;
      }

      const factor = (height - maxHeight) / height;

      let newLen = newText.length - Math.ceil(newText.length * factor / FACTOR);

      if (newLen <= 0) {
        newLen = 0;
      }

      if (len === newLen) {
        break;
      }

      newText = trim(newText.substring(0, newLen));


      len = newText.length;

      div.innerText = newText;
    }

    if (newText === text) {
      removeClass(element, 'sm-ellipsis--truncated');
    } else {
      addClass(element, 'sm-ellipsis--truncated');
    }

    if (onEllipsisChange) {
      onEllipsisChange(newText !== text, element);
    }

    newText = newText !== text ? newText.substring(0, newText.length - reservedLength) : newText;
    newText = `${newText}${dots && newText !== text ? dots : ''}`;
    element.innerHTML = `${prepend}${newText === text ? '' : before}${newText}${newText === text ? '' : after}${append}`;

    div.$onDestroy();
  };

  setTimeout(ellipsis, 30);

  const offResize = onResize(ellipsis);

  return () => {
    offResize();
  };
});



// WEBPACK FOOTER //
// ./src/components/sm-ellipsis/sm-ellipsis.js